

<app-link-report #linkComponent
  [showActionButtons]="false"
  [childIncidentId]="childIncidentId"
  [linkMode]="linkMode"
  [incidents]="incidents"
  (onLink)="onLink($event)">
></app-link-report>

<div class="p-dialog-footer">
  @if (linkMode === 'link') {
    <button type="button" pButton class="" (click)="linkComponent.linkIncident()">Link</button>
  }
  @if (linkMode === 'unlink') {
    <button type="button" pButton class="" (click)="linkComponent.unlinkIncident()">Unlink</button>
  }
  <button type="button" pButton class="p-button-outlined" (click)="modalRef.close('dismissed')">Close</button>
